<script setup lang="ts">
import { useAppIndexStore } from '@base/stores/indexStore'
import { defineShortcuts } from '#ui/composables/defineShortcuts'

const p = defineProps<{
  username: string
  password: string
}>()

const inputUsername: Ref<string> = ref('')
const inputPassword: Ref<string> = ref('')
const msg: Ref<string> = ref('')

defineShortcuts({
  enter: {
    usingInput: 'password', // only fire when the password field is focused — not any input on the page
    handler: () => submit(),
  },
})

function submit(): void {
  if (inputUsername.value.toLowerCase() === p.username.toLowerCase() && inputPassword.value === p.password) {
    msg.value = ''
    const indexStore = useAppIndexStore()
    indexStore.setAccessGranted(true)
  }
  else {
    msg.value = 'Invalid username or password'
  }
}
</script>

<template>
  <div>
    <h1 class="mt-8 mb-2">
      Login
    </h1>
    <div class="mb-2">
      <UInput
        v-model="inputUsername"
        placeholder="Username"
      />
    </div>
    <div class="mb-2">
      <UInput
        v-model="inputPassword"
        placeholder="Password"
        type="password"
        name="password"
      />
    </div>
    <div class="mb-2">
      <UButton
        :disabled="!(inputUsername && inputPassword)"
        @click="submit()"
      >
        Submit
      </UButton>
    </div>
    <p
      v-if="msg"
      class="text-red"
      v-html="msg"
    />
  </div>
</template>
